import {PropertyBase} from "./PropertyBase";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";
import * as React from "react";
import {IconData} from "PageBuilder/utils/Dialogs/IconDialog";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {IconDialog} from "PageBuilder/Dialogs/IconDialog";

export class IconProperty extends PropertyBase{
    public label:string="Label";


    public SubRenderer(): React.ReactNode {
        let option:IconData= this.GetOptionValue();
        return (
            <div style={{cursor:'pointer',width:'100%',textAlign:'center',userSelect:'none'}}>
                <label style={{display:'block',margin:0,textAlign:'left'}}>Icon</label>
                <span style={{border:'1px solid black',fontFamily:'FontAwesome',fontSize:'100px'}} dangerouslySetInnerHTML={{__html:(option as any).Value}} onClick={e=>this.SelectIcon()}/>
            </div>
        )
    }

    private async SelectIcon() {
        let result=await Dialog.Show(<IconDialog/>);
        if(result==null)
            return;
        this.SetOptionValue(result);
        this.ForceUpdate();
    }

}